import * as Yup from 'yup'

export const PASSWORD_MESSAGE =
	'Passwords must have at least 8 characters and include 2 of the following: 1 uppercase letter, 1 number, or 1 special character.'

/**
 * The password rule every form that sets a password shares, so sign-up, password change and
 * profile completion cannot drift apart.
 */
export const passwordSchema = Yup.string()
	.required(PASSWORD_MESSAGE)
	.min(8, PASSWORD_MESSAGE)
	.test('password-complexity', PASSWORD_MESSAGE, value => {
		if (!value) return false
		const hasUpper = /[A-Z]/.test(value)
		const hasDigit = /\d/.test(value)
		const hasSpecial = /[@$#!%*?&._-]/.test(value)
		const score = (hasUpper ? 1 : 0) + (hasDigit ? 1 : 0) + (hasSpecial ? 1 : 0)
		return score >= 2
	})
